import { render, staticRenderFns } from "./QuoteDetailPage.vue?vue&type=template&id=5356cdc9&"
import script from "./QuoteDetailPage.vue?vue&type=script&lang=ts&"
export * from "./QuoteDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports